import * as yup from 'yup';

export default function detailsString(key, field, value) {
  return yup.string().nullable().when(key, { is: value, then: field });
}
